
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"119","height":"27","viewBox":"0 0 119 27","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M118.36 25.87h-9.966l-4.231-6.49-4.158 6.49H90.29l8.819-12.763L90.827.74h9.68l3.656 5.915L107.82.739h9.787l-8.137 11.973 8.89 13.157z","stroke":"#FF5F3C","stroke-width":".476","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M39.387 13.967c3.118 0 4.91-1.434 4.91-4.302 0-2.796-1.792-4.194-4.91-4.194h-5.234v8.497h5.234zm.537 4.733h-5.771v7.17h-5.665V.775h10.899c6.56 0 10.288 3.154 10.288 8.711 0 3.872-1.649 6.668-4.696 8.102l5.342 8.282h-6.418l-3.98-7.17zM54.442.774h5.664v25.094h-5.664V.774zM71.327 21.102h5.127c4.193 0 7.276-3.155 7.276-7.744 0-4.624-3.226-7.815-7.528-7.815h-4.875v15.559zM76.309.775c7.78 0 13.194 5.127 13.194 12.547 0 7.385-5.486 12.548-13.408 12.548H65.662V.775H76.31zM18.634 14.31v5.403c-1.614.82-3.402 1.36-4.91 1.36-4.441 0-7.916-3.406-7.916-7.848 0-4.408 3.435-7.81 7.883-7.81 2.435 0 5.016 1.073 6.877 2.794l.022-.028 2.721-4.397C20.775 1.777 17.2.5 13.691.5 5.876.5 0 5.989 0 13.225 0 20.5 5.769 26.016 13.365 26.016c3.358 0 7.315-1.147 9.902-3.064.275-.202.275-.405.275-1.036v-8.76l-4.908 1.154z","fill":"#330E2F"}})])
          )
        }
      }
    